import {
  ElementFactoryResult,
  InternalElementFactoryOptions,
  SdkElement,
  SdkElementOptionsMap
} from '../../model';
import { DocumentCollectorElementOptions } from './DocumentCollector/DocumentCollectorElement';
import { createDocumentCollectorElement } from './DocumentCollector/createDocumentCollectorElement';
import { LRSElementOptions } from './LRS/LRSElement';
import { createLRSElement } from './LRS/createLRSElement';
import { PaymentElementOptions } from './Payment/PaymentElement';
import { createPaymentElement } from './Payment/createPaymentElement';
import { PaymentInstructionsElementOptions } from './PaymentInstructions/PaymentInstructionsElement';
import { createPaymentInstructionsElement } from './PaymentInstructions/createPaymentInstructionsElement';
import { PaymentMethodSelectorElementOptions } from './PaymentMethodSelector/PaymentMethodSelectorElement';
import { createPaymentMethodSelectorElement } from './PaymentMethodSelector/createPaymentMethodSelectorElement';
import { RecipientFieldsElementOptions } from './RecipientFields/RecipientFieldsElement';
import { createRecipientFieldsElement } from './RecipientFields/createRecipientFieldsElement';

export const ElementFactory = (options: InternalElementFactoryOptions): ElementFactoryResult => {
  const commonOptions = options;
  const elements = {
    payment: async (options: PaymentElementOptions) => {
      return createPaymentElement(options, commonOptions);
    },
    paymentInstructions: async (options: PaymentInstructionsElementOptions) => {
      return createPaymentInstructionsElement(options, commonOptions);
    },
    documentCollector: async (options: DocumentCollectorElementOptions) => {
      return createDocumentCollectorElement(options, commonOptions);
    },
    lrs: async (options: LRSElementOptions) => {
      return createLRSElement(options, commonOptions);
    },
    paymentMethodSelector: async (options: PaymentMethodSelectorElementOptions) => {
      return createPaymentMethodSelectorElement(options, commonOptions);
    },
    recipientFields: async (options: RecipientFieldsElementOptions) => {
      return createRecipientFieldsElement(options, commonOptions);
    }
  };

  return {
    create: <K extends keyof SdkElementOptionsMap>(key: K, options: SdkElementOptionsMap[K]) =>
      (elements[key] as unknown as (opts: SdkElementOptionsMap[K]) => Promise<SdkElement>)(options)
  };
};
